import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import { firebaseConfig } from "../config/firebase";
import { deleteUserToken } from "../helpers/authHelpers";
import { E2E_AUTH_TOKEN, isE2EAuthEnabled } from "../config/e2e";

const e2eAuthEnabled = isE2EAuthEnabled();

const e2eUser = {
  uid: E2E_AUTH_TOKEN,
  displayName: "Playwright Super Admin",
  email: "playwright@example.invalid",
  photoURL: null,
  getIdToken: async () => E2E_AUTH_TOKEN,
  updatePassword: async () => undefined,
} as unknown as firebase.User;

const e2eAuth = {
  currentUser: e2eUser,
  onAuthStateChanged: (observer: (user: firebase.User | null) => unknown) => {
    observer(e2eUser);
    return () => undefined;
  },
  setPersistence: async () => undefined,
  signInWithEmailAndPassword: async () => ({ user: e2eUser }),
  signInWithPopup: async () => ({ user: e2eUser }),
  signOut: async () => undefined,
} as unknown as firebase.auth.Auth;

if (!e2eAuthEnabled) {
  if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig);
  } else {
    firebase.app();
  }
}

export const auth = e2eAuthEnabled ? e2eAuth : firebase.auth();
export const firestore = e2eAuthEnabled
  ? (null as unknown as firebase.firestore.Firestore)
  : firebase.firestore();

// ensure persistence across page reloads; local ties to the browser, but
// session could also be used depending on requirements.  Explicitly setting it
// avoids ambiguity in environments like tests where the default can vary.
// note: this returns a promise, but we don't need to await it when the app
// starts since persistence is usually configured before any sign-in occurs.
try {
  // setPersistence rejects asynchronously in browsers, but throws synchronously
  // in environments like jsdom (tests) where the persistence type is
  // unsupported — guard both so module load never crashes the app.
  if (!e2eAuthEnabled) {
    auth.setPersistence(firebase.auth.Auth.Persistence.LOCAL).catch((err) => {
      console.warn('Failed to set auth persistence', err);
    });
  }
} catch (err) {
  console.warn('Failed to set auth persistence', err);
}

const provider = e2eAuthEnabled ? null : new firebase.auth.GoogleAuthProvider();

export const signInWithGoogle = () => {
  if (provider) {
    return auth.signInWithPopup(provider);
  }
  return Promise.resolve({ user: e2eUser });
};

export const signOut = () => auth.signOut().then(deleteUserToken);
